/* eslint-disable react-refresh/only-export-components */
import { createContext, useCallback, useContext, useMemo, useState } from "react";
import PropTypes from "prop-types";
import LoaderGif from "@/assets/images/veegil_loader/Loader.gif";

export const LoaderContext = createContext();
export const useLoader = () => useContext(LoaderContext);

export const LoaderProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  const showLoader = useCallback(() => setIsLoading(true), []);
  const hideLoader = useCallback(() => setIsLoading(false), []);

  const value = useMemo(
    () => ({ isLoading, showLoader, hideLoader }),
    [isLoading, showLoader, hideLoader]
  );

  return (
    <LoaderContext.Provider value={value}>
      {children}
      {isLoading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black-transparent">
          <div className="w-16 h-16">
            <img src={LoaderGif} alt="Loading..." className="w-full h-full" />
          </div>
        </div>
      )}
    </LoaderContext.Provider>
  );
};

LoaderProvider.propTypes = {
  children: PropTypes.node,
};
